import { useNavigate } from "react-router-dom";
import { AppDispatch } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { resetRedirectingFlag } from "@/database";

// import { SOCKET_STATE, apiUserLogin } from '@b2b-client/shared-services';

const userInitState = {
  isLoggedIn: false,
  userId: "",
  username: "",
  email: "",
  token: "",
  name: "",
  userSocialChannels: [],
};

const authSlice = createSlice({
  name: "app",
  initialState: {
    user: userInitState,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = { ...state, ...action.payload, isLoggedIn: true };
      // Reset the redirecting flag when user is successfully set
      resetRedirectingFlag();
    },
    logout: (state, action) => {
      state.user = userInitState;
    },
  },
});

interface LoginParams {
  name: string;
  email: string;
  username: string;
  token: string;
}

export const userLogin = (payload: LoginParams) => {
  return async (dispatch: AppDispatch) => {
    dispatch(setUser(payload));
  };
};

export const { setUser, logout } = authSlice.actions;

export default authSlice.reducer;
